import { Button, Card, Col, Form, message, Modal, Row, Upload } from "antd";
import { CustomBtn } from "../../../../components/commonComponents";
import { useState } from "react";
import { useAppContext } from "../../../../hooks/useAppContext";
import { replaceDocument } from "../actions";

export default function DocReplaceModal({ open, close, doc, setDocToEdit, messageApi }) {
    const [form] = Form.useForm()
    const [fileList, setFileList] = useState([])
    const { refreshDocs } = useAppContext()
    
    const closeModal = () => {
        close(false)
        setDocToEdit(null)
    }

    const onFinish = async (values) => {
        
        if (!values?.library_doc?.fileList[0]?.status) {
            const formData = new FormData()
            formData.append('library_doc', fileList[0])

            replaceDocument(formData, doc.id).then(() => {
                messageApi.success('დოკუმენტი წარმატებით ჩანაცვლდა')
                refreshDocs()
                closeModal()
            }).catch((error) => {
                console.log(error)
                messageApi.error(error.message)
            })
        }
    }

    const fileprops = {
        name: 'file',
        multiple: false,
        showUploadList: {
            showDownloadIcon: false,
        },
        onRemove: (file) => {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
        },
        beforeUpload: (file) => {
            setFileList([file]);
            return false;
        },
        fileList,
    };

    return (
        <Modal open={open}
            onCancel={closeModal}
            title='დოკუმენტის ჩანაცვლება'
            footer={[
                <CustomBtn key='submit' onClick={form.submit} label={'ატვირთვა'} color='#eb2f96' htmlType="submit" icon={<i className="fa-solid fa-ban" style={{ color: 'white', fontSize: 22, }}></i>} />,
                <CustomBtn key='cancel' onClick={closeModal} label={'დახურვა'} color='#8c8c8c' htmlType="button" icon={<i className="fa-solid fa-xmark" style={{ color: 'white', fontSize: 22, }}></i>} />
            ]}
        >
            <Card
                title={
                    <div style={{ display: 'inline-block', lineHeight: 1.5, width: '100%' }}>
                        <div style={{ width: '100%', textAlign: 'center' }}>{doc?.department + '-' + doc?.hierarchy + '-' + doc?.number}</div>
                        <hr style={{ margin: 0 }} />
                        <div style={{ width: '100%'}}>{doc?.name}</div>
                    </div>
                }
            >
                <Row>
                    <Col span={24}>
                        <p style={{ color: 'red', padding: 10, textAlign: 'justify' }}>დოკუმენტის ატვირთვისას მოხდება არსებული ფაილის ჩანაცვლება. ჩანაცვლების შემთხვევაში დოკუმენტის აღდგენა იქნება შეუძლებელი!!!</p>
                    </Col>
                    <Col span={24} style={{ display: 'flex', justifyContent: 'center' }}>
                        <Form
                            form={form}
                            onFinish={onFinish}
                            layout='vertical'
                        >
                            <Form.Item name='library_doc' label='დოკუმენტი' rules={[{ required: true, message: 'დოკუმენტის ატვირთვა სავალდებულოა' }]}>
                                <Upload
                                    {...fileprops}
                                    maxCount={1}
                                    accept=".pdf,.docx,.doc"
                                    customRequest
                                >
                                    <Button icon={<i className="fa-solid fa-upload"></i>} style={{ width: '100%' }}>
                                        ატვირთვა
                                    </Button>
                                </Upload>
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>
            </Card>
        </Modal>
    )
}